<script lang="ts" setup>
const actionsStore = useActionsStore()
</script>

<template>
  <CompaniesTable
    :action="actionsStore.selectedAction"
    feature="search"
    has-selection
    :scroll-top-on-page-change="false"
    view="search"
    wrapper-classes="min-h-[620px]"
  >
    <template #header="{ companies, count }">
      <SegmentationHorizontal
        :companies="companies"
        feature="search"
        has-sort-reset
        :query-count="count"
      />
    </template>
  </CompaniesTable>
</template>
